
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateRoletypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(45)]),
    label: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(2000)]),
    defaultForNewEmployees: new FormControl<boolean | undefined>(false),
})
;
}
      